export default "__VITE_ASSET__0wMuTnWK__"